import React from "react";

const ProgressSteps = ({ currentStep, totalSteps, header }) => {
  return (
    <div style={{ width: "100%", maxWidth: "32rem" }}>
      <div className="flex justify-between mb-4">
        <span className="text-xl font-bold text-gray-500">{header}</span>
        <span>
          <span className="text-xs text-gray-500 bg-gray-50 px-2 py-1 rounded-xl h-auto">
            Step {currentStep <= 9 ? `0${currentStep}` : currentStep} of{" "}
            {totalSteps <= 9 ? `0${totalSteps}` : totalSteps}
          </span>
        </span>
      </div>

      <div className="flex gap-3">
        {[...Array(totalSteps)].map((step, index) => {
          if (index + 1 < currentStep)
            return (
              <div className="h-[6px] w-[25%] bg-primary-500 rounded-[18px]"></div>
            );
          else if (index + 1 === currentStep)
            return (
              <div className="h-[6px] w-[25%] bg-gray-150 rounded-[18px]">
                <div className="h-[6px] w-[85%]  bg-primary-500 rounded-[18px]"></div>
              </div>
            );
          else
            return (
              <div className="h-[6px] w-[25%] bg-gray-150 rounded-[18px]"></div>
            );
        })}
      </div>
    </div>
  );
};

export default ProgressSteps;
